<template>
  <div class="reset-page">
    <h4 class="pa-4 white--text text-center">
      {{ text1 }} <br />
      {{ text2 }}
    </h4>
    <v-btn rounded large :loading="loading" class="secondary white--text" @click="gotoAsta()">{{ btnText }}
      <template v-slot:loader>
        <img class="spinner" :src="firebase_host + '/static/gif/circle.gif'" /> </template></v-btn>
  </div>
</template>

<script>
import ge from "../../js/globalEvent";
import mixins from "../../js/mixins";
import db from "../../js/db";
import Config from "../../../config-app/config";

export default {
  name: "reset",
  mixins: [mixins],
  data() {
    return {
      loading: false,
      firebase_host: Config.FIREBASE_HOST,
      text1: (this.$route.query.type == "sessionExists") ? "Asta Live risulta già aperta" : "",
      text2: (this.$route.query.type == "sessionExists") ? "Puoi avere aperta solo una sessione alla volta." : "Hai lasciato Asta Live",
      btnText: (this.$route.query.type == "sessionExists") ? "Continua in questa finestra" : "Torna in Asta Live"
    };
  },
  mounted() {
    console.log("--> Reset ready.");
  },
  destroyed() {
    console.log("<-- Reset destroyed.");
  },
  methods: {
    async gotoAsta() {
      let asta_id = this.$route.query.asta_id
      await db.resetPresence(asta_id);
      this.loading = true;
      await this.wait(2000);

      if (Config.STANDALONE) {
        // voglio che compaia il doppio id_asta nell'url (c'è già quello ?ID_Lega nell'url Fantapazz)
        this.$router.push({ path: "/asta/" + asta_id });
      } else {
        this.$router.push({ path: "/" });
      }

      // window.location.reload();
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../../main.scss";

.reset-page {
  height: 100vh;
  background-color: var(--v-primary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .spinner {
    width: 25px;
  }
}
</style>
